export default function setRouteDirection(
  destinationLat,
  destinationLng,
  travel,
  fLat,
  fLng,
  service,
  renderer
) {
  const dS = service;
  const dR = renderer;

  const fromLat = fLat;
  const fromLng = fLng;

  let totalDist = null;
  let totalTime = null;

  const computeTotals = result => {
    const myroute = result.routes[0];
    for (let i = 0; i < myroute.legs.length; i += 1) {
      totalDist = myroute.legs[i].distance.text;
      totalTime = myroute.legs[i].duration.text;
    }

    const container = document.querySelectorAll('[data-module="TotalTimeDistance"]');
    if (container && totalTime !== null && totalDist !== null) {
      const timeContainer = container[0].querySelector(
        '[data-child-module="TotalTimeDistance__Time"]'
      );
      timeContainer.innerHTML = totalTime;

      const distanceContainer = container[0].querySelector(
        '[data-child-module="TotalTimeDistance__Distance"]'
      );
      distanceContainer.innerHTML = totalDist;
    }
  };

  const request = {
    origin: new google.maps.LatLng(fromLat, fromLng),
    destination: new google.maps.LatLng(fromLat, fromLng),
    travelMode: google.maps.TravelMode[travel]
  };

  if (destinationLat != null && destinationLng != null) {
    request.destination = new google.maps.LatLng(destinationLat, destinationLng);
  }

  dS.route(request, (result, status) => {
    if (status === google.maps.DirectionsStatus.OK) {
      dR.setPanel(null);
      dR.setDirections(result);

      computeTotals(result);
    }
  });
}
